import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { DtoStudentDetails } from '../../models/edmart.model';
import { environment } from '../../app/environments/environment.development';
import { constantvalues } from '../../const';

@Injectable({
    providedIn: 'root'
})
export class EdmartService {
    baseURL: string;
    constructor(private httpClient: HttpClient) {
        this.baseURL = environment.gatewayUrl;
    }

    getStudentDetails(studentId: string): Observable<DtoStudentDetails | null> {
        return this.httpClient.get<DtoStudentDetails | null>(`${this.baseURL}${constantvalues.EDMART_URL.STUDENT_DETAILS}/${studentId}`);
    }
}

